import { TemplateResult, html } from 'lit';
import {
  LightDomStyles,
  OutlineElement,
  SlotsController,
} from '@phase2/outline-core';
import { customElement, query } from 'lit/decorators.js';
import componentStyles from './outline-event-card.css.lit';
import placeholderImage from '../../assets/images/placeholder-image.png';

/**
 * The OutlineEventCard component
 * @element outline-event-card
 */
@customElement('outline-event-card')
export class OutlineEventCard extends OutlineElement {
  static styles = [componentStyles];

  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  slots = new SlotsController(this);

  @query('slot[name="cta"]')
  ctaSlot: HTMLSlotElement;

  connectedCallback(): void {
    super.connectedCallback();
    this.addEventListener('click', this.handleClick);
  }

  handleClick(): void {
    // Get all nodes assigned to the 'cta' slot.
    const assignedNodes = this.ctaSlot.assignedNodes({ flatten: true });

    // Recursive function to search for an <a> tag.
    const findLink = (nodes: Node[]): HTMLAnchorElement | null => {
      for (const node of nodes) {
        if (node.nodeName === 'A') {
          return node as HTMLAnchorElement;
        } else if (node instanceof HTMLSlotElement) {
          const slotAssignedElements = node.assignedElements({ flatten: true });
          const slotResult = findLink(slotAssignedElements);
          if (slotResult) {
            return slotResult;
          }
        } else if (node.childNodes.length > 0) {
          const childResult = findLink(Array.from(node.childNodes));
          if (childResult) {
            return childResult;
          }
        }
      }
      return null;
    };

    // Find the first <a> tag in the assigned nodes.
    const link = findLink(assignedNodes);

    if (link) {
      link.click();
    }
  }

  render(): TemplateResult {
    return html`
      <article class="event-card">
        ${this.slots.exist('image')
          ? html` ${this.slots.conditionalSlot('image', false)} `
          : html`
              <div class="image image--placeholder">
                <img src="${placeholderImage}" alt="" />
              </div>
            `}
        <div class="content">
          ${this.slots.conditionalSlot('date', false)}
          <hr class="rule" />

          ${this.slots.conditionalSlot('title', false)}
          ${this.slots.conditionalSlot('time', false)}
          ${this.slots.conditionalSlot('location', false)}
          ${this.slots.conditionalSlot('cta', false)}
        </div>
      </article>
    `;
  }
}
